import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import BlurModal from '../../components/common/blur-modal';
import { InstatntMessenger, PDF, CallBackRequest } from '@dbk/ui-icons';
import { PALETTE,INVESTMENT_CONSTANTS,INVESTMENT_API_CODES } from '../../constants';
import Button from '@dbk/ui-buttons';
import { LoadingCircle } from '../../components/common/loading';
import ErrorPopup from './error-toast';



class Details extends Component{

    constructor(props){
    super(props);
    var currentLocation = window.location.pathname;

    var articleid = currentLocation.split('/')[4] || currentLocation.split('/')[3];
    this.props.getArticle( articleid );

    this.state = {
      downloading: false,
      fileError: false,
      requestCallBack:false,
      rmModal:false,
      modal:false,
      navigate:false
    };
    }

    componentWillMount(){
      this.props.setDetailsPage(true)
    }

    componentWillUnmount() {
        this.props.clearArticle();
    }
    
    componentDidUpdate(prevProps, prevState) {
        const attachementFile = this.props.investmentIdeas.attachmentFile;
    
        if (attachementFile != null && attachementFile.pdfData != null) {
          setTimeout(() => {
            this.setState({
              downloading: false,
              fileError: false,
            });
          }, 500);
        }
    }

    modalContent(attachementFile) {
        const { i18n: { messages }} = this.props;
        if (attachementFile === null || this.state.downloading === true) {
          return (
            <div className="pad-bottom-30">
              <LoadingCircle />
            </div>
          );
        }
        let url = "data:application/pdf;base64," + attachementFile.pdfData;
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          if (!attachementFile.pdfData || attachementFile.pdfData === '') {
            return (
              <div>{messages['app.reports.unablePdf']}</div>
            );
          }
    
          var byteCharacters = atob(attachementFile.pdfData);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], {
            type: 'application/pdf'
          });
          this.closeBlurModel();
          window.navigator.msSaveOrOpenBlob(blob, 'Article');
        }
        else {
          if (!attachementFile.pdfData || attachementFile.pdfData === '') {
            return (
              <div>{messages['app.reports.unablePdf']}</div>
            );
          }
          return (
            <div className="pad-10">
              <embed src={url} width="100%" style={{ 'minHeight': window.innerHeight }} />
            </div>
          )
        }
    }

    closeBlurModel() {
        this.setState({ modal: false });
    }

    renderPDFButton(data) {
        const { i18n: { messages }} = this.props;
        
        if (!data.attachments || data.attachments.length === 0) {
          return null;
        } else {
          let attachment = data.attachments[0].attachmentId;
          return (
            <div className="reply-button-view">
            <div className="insight-button">
    
    
              <div>
                {this.state.downloading === false &&
    
                <Button fullWidth size="large" onPress={() => this.openPDF(attachment)} style={{}} >
                    <div className="pdf-button">
                        <PDF width={25} height={25} color={PALETTE.secondaryActive}/>
                        <div className="pdf-button-text">{messages['app.insight.viewPdf']}</div>
                    </div>
                </Button>
    
                }
                {this.state.downloading === true &&
                  <div className="pad-bottom-30">
                    <LoadingCircle />
                  </div>
                }
              </div>
            </div>
            </div>
          );
        }
    
    }

    openPDF(attachment) {
        this.setState({ downloading: true });
        this.props.download(attachment);
    
        setTimeout(() => {
          this.setState({ modal: true });
        });
    
    }

    onCloseErrorToast = () => {
      this.props.goBack();
    }
    submitRequest() {
  
      const input = {
        screen: 'dbXpert TopPicks',
        context: 'dbXpert TopPicks-'+this.props.investmentIdeas.articleContent.title,
        investmentIdeaId : window.location.pathname.split('/')[4] || window.location.pathname.split('/')[3]

      };
      
      this.props.sendRMCallBack({input}).then((success) => {
        this.setState({ rmModal: true });
      });
    }

    closeRMCallBack() {
      this.setState({
        rmModal:false
      },()=>this.setState({requestCallBack:false},()=>this.props.changePage('/portfolios',true)))
    }

    render(){
        const attachmentFile = this.props.investmentIdeas.attachmentFile;
        const article = this.props.investmentIdeas.articleContent;
        const isLoading = this.props.investmentIdeas.isLoading;
        const { i18n: { messages },callback: { displayMsg, success} } = this.props;
        
        let backGroundColorIdeaType="";
        if(article){
          backGroundColorIdeaType = article.ideaType === INVESTMENT_CONSTANTS.BUY ? "buy-color" :  article.ideaType === INVESTMENT_CONSTANTS.SELL ? "sell-color" : "switch-color" 
        }
        if(isLoading) {
            return (<div className="center-content" style={{ 'minHeight': window.innerHeight - 100 }}><LoadingCircle /></div>);
        }
        if (!article) {
          if(this.props.investmentIdeas.detailError){
          return  ( 
            <div>
           <ErrorPopup header="Connection Error" message={this.props.investmentIdeas.detailError} onClose={this.onCloseErrorToast} containerStyle={{paddingTop: 200,  paddingLeft: "30%", width: "70%"}}/>
             </div>
          );
         }
         else {
           return null;
         }
        }
        this.props.clearError("")
        return(
            <div className="page-content">
                <div className="image-frame" style={{backgroundColor:article.assetColorcode}}>
                    <div className="image-text">{article.assetType}</div>
                </div>
                <div className={`action-frame ${backGroundColorIdeaType}`}>
                    <div className="action">{article.ideaType}</div>
                </div>
                <div className="info-content">
                    
                    <div className="info-title">{article.title}</div>
                    <div className="info-date">{article.date}</div>
                    <div className="image-container">
                    { article.image.uri != '' &&
                      <img className="content-image" src={article.image.uri} />
                    }
                    </div>
                        {this.renderPDFButton(article)}
                    
                    <pre className="info-desc">{article.desc}</pre>
                    <div className="reply-button-view">
                        <div className="insight-button">
                            <Button fullWidth size="large" onPress={() => this.setState({requestCallBack:true})} secondary>
                                <div className="pdf-button">
                                    <CallBackRequest width={25} height={25} color="#fff"/>
                                    <div className="pdf-button-text">{messages['app.insight.requestCallBack']}</div>
                                </div>
                            </Button>
                        </div>
                    </div>
                </div>
                {this.props.investmentIdeas.showPdfModal && this.state.modal ? 
                <BlurModal
                    visible={this.state.modal}
                    doneLabel={messages['app.calendar.doneBtn']}
                    doneVisible={true}
                    onDone={() => this.setState({ modal: false })}
                    headerChildren={messages['app.common.pageTitle.investmentsIdeas']}
                >
                    {this.modalContent(attachmentFile)}
                </BlurModal> 
                : null}
                {
                    this.state.requestCallBack ?

                    <BlurModal
                        visible={this.state.requestCallBack}
                        doneLabel={messages['app.calendar.doneBtn']}
                        doneVisible={false}
                        onDone={() => this.setState({requestCallBack:false})}
                        headerChildren={messages['app.insight.requestCallBack']}
                        // style= {styles.rmCallBackModal}
                    >
                        <div>
                            <div className="box">
                                <div className="imageView" style={{backgroundColor:article.assetColorcode}}>
                                    {article.assetType}
                                </div>    
                                <div className="rightContainer"> 
                                    <div className="blackColor">{messages['app.common.pageTitle.investmentsIdeas']}</div>
                                    <div className="rmCallBackTitle"/>   
                                    <div className="blackColor">{article.title}</div>  
                                </div>       
                            </div>
                            <div className="rmCallBackDetails">{messages['app.insight.requestCallBackText']}</div>
                            <div style={{backgroundColor:'blue'}}>
                              <Button fullWidth size="large" onPress={()=>this.submitRequest()}>
                                  <div className="pdf-button">
                                      <div className="rm-button-text">{messages['app.rmcallback.subReq']}</div>
                                  </div>
                              </Button>  
                            </div>  
                            { 
                              this.state.rmModal ?<BlurModal
                                  onDone={()=>this.closeRMCallBack()}
                                  visible={this.state.rmModal}
                                  // headerChildren={success ? messages['app.rmcallback.reqSub'] : messages['app.rmCallback']}
                                >
                                  <div className="center">
                                    <div className="text-center-flex">{displayMsg}</div>
                                    <div className="text-center-flex">
                                    <div className="margin-top-50 width-200">
                                      <Button size="large" onPress={()=>this.closeRMCallBack()}>
                                            <div className="rm-button-text"> {messages['app.rmcallback.okMsg']}</div>
                                      </Button>
                                    </div>
                                    </div>
                                  </div>
                                </BlurModal> : null
                            }
                        </div>
                    </BlurModal>    
                    :null
                }
            </div>
        );
    }

    
}


export default createContainer({
    $queries: {
      changePage: { $call: 'ui.history.push' },
      rsaChangePage: { $call: 'rsa.changePage' },
      goBack:{ $call: 'ui.history.goBack'},
      getArticle: {
        $call: 'investmentIdeas.getArticle',
      },
      download: {
        $call: 'investmentIdeas.getAttachment',
      },
      clearfiles: {
        $call: 'investmentIdeas.clearAttachment',
      },
      clearArticle: {
        $call: 'investmentIdeas.clearArticle',
      },
      clearError: {
        $set: 'investmentIdeas.detailError'
      },
      sendRMCallBack: {
        $call: 'callback.getResponse',
      },
      callback: {
        displayMsg: true,
        success: true,
      },
      i18n: {
        messages: true,
      },
      investmentIdeas: {
        showPdfModal: true,
        articleContent: true,
        attachmentFile: true,
        isLoading: true,
        detailError: true,
        attachmentError: true
      },
      setDetailsPage: {
        $set: 'investment.fromDetailsPage'
      },
    },
  })(Details);